<div class="rv-rows small">
  <riv-alphabetic-field
    [maxLength]="maxInputLength"
    [value]="_.from"
    (valueChange)="_.changeFrom($event)"
    [required]="true"
    [casing]="'upper'"
  ></riv-alphabetic-field>
  <div class="combiner rv-low-contrast">through</div>
  <riv-alphabetic-field
    [maxLength]="maxInputLength"
    [value]="_.to"
    (valueChange)="_.changeTo($event)"
    [required]="true"
    [casing]="'upper'"
  ></riv-alphabetic-field>
</div>
